import { action, computed, observable } from 'mobx';
import { setter, toggle } from 'mobx-decorators';
import * as constants from 'Constants';
import * as utils from 'Utils';
import { deserializeWithMappers, setFieldValues } from 'stores/Utils';



class ModalConfigStore {

  @setter @toggle @observable displayOnLoad;
  @setter @observable title;
  @setter @observable descHtml;
  @setter @observable footerHtml;
  @setter @observable btnText;

  @setter @toggle @observable displaySubmitted;
  @setter @observable submittedHtml;
  @setter @observable submittedCloseText;

  @setter @observable customCssStyles;
  @setter @observable cssClasses;

  @setter @observable variantsPlaceholder;
  @setter @observable emailPlaceholder;

  @setter @toggle @observable autofillDetails;
  @setter @toggle @observable displaySubscribeOption;
  @setter @observable subscribeLabel;

  static create(data={}) {
    const instance = new ModalConfigStore();
    setFieldValues(instance, data);
    return instance;
  }

  static getDefaults() {
    return {
      "displayOnLoad": false,
      "title": "",
      "descHtml": "",
      "footerHtml": "",
      "btnText": "",

      "displaySubmitted": false,
      "submittedHtml": '',
      "submittedCloseText": '',

      "customCssStyles": "",
      "cssClasses": [],

      "variantsPlaceholder": "",
      "emailPlaceholder": "",

      "autofillDetails": false,
      "displaySubscribeOption": false,
      "subscribeLabel": "",
    };
  }

  constructor(defaults=ModalConfigStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  @action reset(defaults=ModalConfigStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  getDeserializeMappers() {
    return [
      {"field": "displayOnLoad", "accessor": "display_onload"},
      {"field": "title", "accessor": "title"},
      {"field": "descHtml", "accessor": "desc_html"},
      {"field": "footerHtml", "accessor": "footer_html"},
      {"field": "btnText", "accessor": "btn_text"},

      {"field": "displaySubmitted", "accessor": "display_submitted"},
      {"field": "submittedHtml", "accessor": "submitted_html"},
      {"field": "submittedCloseText", "accessor": "submitted_close_text"},

      {"field": "customCssStyles", "accessor": "custom_css_styles"},
      {"field": "cssClasses", "accessor": "css_classes"},

      {"field": "variantsPlaceholder", "accessor": "variants_placeholder"},
      {"field": "emailPlaceholder", "accessor": "email_placeholder"},

      {"field": "autofillDetails", "accessor": "autofill_details"},
      {"field": "displaySubscribeOption", "accessor": "display_subscribe_option"},
      {"field": "subscribeLabel", "accessor": "subscribe_label"},
    ];
  }

  @action async deserialize(data) {
    await deserializeWithMappers(this, this.getDeserializeMappers(), data);
  }
}

export default ModalConfigStore;



